.controlStack--controls--kgY {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 32px;
  z-index: 1;
}

.controlSingle--controls--9xL {
  position: absolute;
  z-index: 1;
}

.button--controls--zky {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: var(--map-control-bg, #181d23);
  color: var(--map-control-color, #ffffff);
  box-shadow: var(--map-control-shadow, none);
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.button--controls--zky:hover {
  background-color: var(--map-control-hover-bg, #252b33);
}
.button--controls--zky:active {
  background-color: var(--map-control-active-bg, #1c2128);
}
.button--controls--zky:focus-visible {
  outline: 2px solid var(--map-control-focus, rgba(255, 255, 255, 0.5));
  outline-offset: 2px;
}.icon16x16--Icons--OrM {
  width: 16px;
  height: 16px;
}

.icon20x20--Icons--HZ1 {
  width: 20px;
  height: 20px;
}

.icon40x40--Icons--nRo {
  width: 40px;
  height: 40px;
}.point--Points--Z-x {
  cursor: pointer;
}
.point--Points--Z-x:hover {
  transform: scale(1.4);
}.map--Map--Zj4 {
  --map-control-bg: #181d23;
  --map-control-hover-bg: #252b33;
  --map-control-active-bg: #1c2128;
  --map-control-color: #ffffff;
  --map-control-focus: rgba(255, 255, 255, 0.5);
  --map-control-shadow: none;
}
.map--Map--Zj4[data-theme=light] {
  --map-control-bg: #ffffff;
  --map-control-hover-bg: #eff1f6;
  --map-control-active-bg: #e0e4ec;
  --map-control-color: #181d23;
  --map-control-focus: rgba(24, 29, 35, 0.45);
  --map-control-shadow: 0 1px 4px rgba(24, 29, 35, 0.16);
}
.map--Map--Zj4 {
  position: relative;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
}
.map--Map--Zj4:fullscreen {
  width: 100%;
  height: 100%;
}

.mapContainer--Map--71z {
  width: 100%;
  height: 100%;
}

.maplibregl-popup.maplib-point-popup .maplibregl-popup-tip {
  display: none;
}
.maplibregl-popup.maplib-point-popup .maplibregl-popup-content {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  max-width: none !important;
}.popup--Popup--qu4 {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
  border: 1.5px solid var(--popup-color);
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  color: #000c37;
  white-space: nowrap;
  user-select: none;
}

.clickable--Popup--zeS {
  cursor: pointer;
}
.clickable--Popup--zeS:hover {
  opacity: 0.85;
}

.pointPopup--Popup--uJR {
  padding: 8px 12px;
  box-shadow: 0 4px 15px rgba(58, 112, 191, 0.1);
  font-weight: 500;
  line-height: 20px;
}
.pointPopup--Popup--uJR::after {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 8px;
  height: 8px;
  transform: translateX(-50%) rotate(45deg);
  background: #fff;
  border-right: 1.5px solid var(--popup-color);
  border-bottom: 1.5px solid var(--popup-color);
  left: 50%;
}

.routePopup--Popup--z42 {
  box-shadow: 0 10px 30px rgba(58, 112, 191, 0.15);
}
.routePopup--Popup--z42::after {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 8px;
  height: 8px;
  transform: translateX(-50%) rotate(45deg);
  background: #fff;
  border-right: 1.5px solid var(--popup-color);
  border-bottom: 1.5px solid var(--popup-color);
  left: 50%;
}

.pill--Popup--KTQ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4px;
  padding: 4px 6px;
  border-radius: 4px;
  height: 28px;
  box-sizing: border-box;
}

.reference--Popup--WMD {
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--popup-color);
}

.count--Popup--8cr {
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #000c37;
}

.route--Popup--Pzy {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 10px 8px;
  font-weight: 500;
  line-height: 20px;
}/*$vite$:1*/